import React from "react";
import Modal from "../../../../../../../commons/modal/Modal";
import { strings } from "../../../../../../../../intl/fa";
import { ButtonVariant } from "@bale/ui";

const getLabels = (nextState: boolean) => {
  if (nextState) {
    return {
      title: strings.campaign_state_modal.activate.title,
      content: strings.campaign_state_modal.activate.content,
    };
  } else {
    return {
      title: strings.campaign_state_modal.pause.title,
      content: strings.campaign_state_modal.pause.content,
    };
  }
};

type Props = {
  onClose: () => void;
  changeState: (state: boolean) => void;
  nextState: boolean;
  loading: boolean;
};
export const ConfirmCampaignStateModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { title, content } = getLabels(props.nextState);
  return (
    <Modal
      title={title}
      content={content}
      primaryButton={{
        onClick: () => {
          props.changeState(props.nextState);
        },
        label: strings.common.button.sure,
      }}
      primaryLoading={props.loading}
      onClose={(e) => {
        e?.stopPropagation();
        props.onClose();
      }}
      secondaryButton={{
        onClick: props.onClose,
        label: strings.common.button.cancel,
        // variant: ButtonVariant.Outlined,
      }}
    />
  );
};
